import {
  BookMarked,
  Building2,
  Camera,
  Church,
  FileText,
  GitBranch,
  HeartHandshake,
  Landmark,
  Scale,
  Sparkles,
} from 'lucide-react';

export const PARTNER_CONTACT_EMAIL = 'support@mylegacybridge.com';

/** Future partner record shape — for referral tracking and logo carousel when confirmed. */
export const PARTNER_RECORD_FIELDS = {
  partner_code: 'string',
  referral_link: 'string',
  qr_referral_link: 'string',
  partner_type: 'string',
  partner_contact_email: 'string',
  partner_status: 'prospect | active | paused',
  referrals_count: 'number',
  conversions_count: 'number',
};

/** Confirmed partners with logos — empty until real partnerships exist. */
export const CONFIRMED_PARTNERS = [];

export const HOMEPAGE_PARTNER_TYPES = [
  'Funeral homes',
  'Faith communities',
  'Care homes',
  'Hospices',
  'Genealogy groups',
  'Celebrants',
];

export const PARTNER_TYPE_CARDS = [
  {
    id: 'funeral-homes',
    icon: Building2,
    title: 'Funeral homes',
    benefit: 'Offer families a gentle aftercare resource for stories, memorial pages and keepsakes.',
  },
  {
    id: 'faith-churches',
    icon: Church,
    title: 'Churches & faith communities',
    benefit: 'Support remembrance, storytelling and legacy within your congregation.',
  },
  {
    id: 'mosques-centres',
    icon: Landmark,
    title: 'Mosques & community centres',
    benefit: 'Introduce a private archive families can use at their own pace.',
  },
  {
    id: 'hospices-care',
    icon: HeartHandshake,
    title: 'Hospices & care homes',
    benefit: 'Help families capture voices and memories before they are lost.',
  },
  {
    id: 'celebrants',
    icon: Sparkles,
    title: 'Celebrants',
    benefit: 'Connect ceremonies to lasting archives and memorial pages.',
  },
  {
    id: 'genealogy',
    icon: GitBranch,
    title: 'Genealogy groups',
    benefit: 'Give members a structured home for stories, documents and connections.',
  },
  {
    id: 'historians',
    icon: BookMarked,
    title: 'Local historians',
    benefit: 'Preserve community memory with context families can keep.',
  },
  {
    id: 'photographers',
    icon: Camera,
    title: 'Family photographers & videographers',
    benefit: 'Extend your work into private archives and Legacy Books.',
  },
  {
    id: 'estate-planning',
    icon: Scale,
    title: 'Will writers & estate planning',
    benefit: 'Offer clients a meaningful way to preserve personal legacy alongside documents.',
  },
];

export const PARTNER_USE_STEPS = [
  {
    step: 1,
    title: 'Display a poster or QR code',
    copy: 'Place a calm, printable MyLegacyBridge poster where families can discover it when they are ready.',
  },
  {
    step: 2,
    title: 'Share MyLegacyBridge with families',
    copy: 'Introduce a private archive — no pressure, no public exposure until they choose.',
  },
  {
    step: 3,
    title: 'Help families create archives, memorial pages or Legacy Books',
    copy: 'Families can start with one story, one voice note or one photo and grow over time.',
  },
];

export const PARTNER_BENEFITS = [
  'Give families a meaningful aftercare resource',
  'Offer a modern memorial option',
  'Support storytelling before and after loss',
  'Provide QR keepsake and Legacy Book pathways',
  'Receive referral tracking later',
  'Be listed as a trusted partner later',
];

export const PARTNER_MATERIALS = [
  { id: 'a4-poster', label: 'A4 poster', description: 'Reception or noticeboard display' },
  { id: 'desk-flyer', label: 'Reception desk flyer', description: 'Compact handout for families' },
  { id: 'qr-explainer', label: 'Memorial QR card explainer', description: 'How QR keepsakes connect to memorial pages' },
  { id: 'funeral-sheet', label: 'Funeral home information sheet', description: 'Overview for aftercare conversations' },
  { id: 'faith-poster', label: 'Faith & community noticeboard poster', description: 'For churches, mosques and community spaces' },
];

export function partnerMailto(subject, body = '') {
  const params = new URLSearchParams();
  if (subject) params.set('subject', subject);
  if (body) params.set('body', body);
  const query = params.toString();
  return `mailto:${PARTNER_CONTACT_EMAIL}${query ? `?${query}` : ''}`;
}

export const PARTNER_MAIL_SUBJECTS = {
  becomePartner: 'Partner enquiry — MyLegacyBridge',
  requestMaterials: 'Partner materials request — MyLegacyBridge',
  contact: 'Partner question — MyLegacyBridge',
};
